import React from "react" 
import { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addRegion, getRegionById, updateRegion } from "service/api"

const defaultValue = {
  region: ""
}

// const AddRegion = () => {

//   const[region, setRegion] = useState(defaultValue);  

//   const navigate = useNavigate();

//   const onValueChange = (e) => {
//     setRegion({...region, [e.target.name]: e.target.value});
//     console.log(e.target.value);
//   }

//   const handleAddRegion = async(e) => {
//     e.preventDefault();
//     await addRegion(region);
//     console.log(region)
//     navigate("/region")
//         toast.success("User saved successfully.", {
//           position: "top-center",
//           autoClose: 1500,
//         })
//   }


// const AddRegion = () => {
//   const [region, setRegion] = useState(defaultValue)
//   const [errors, setErrors] = useState({})
//   const [loading, setLoading] = useState(false)
//   const navigate = useNavigate()

//   const onValueChange = (e) => {
//     setRegion({ ...region, [e.target.name]: e.target.value })
//     setErrors({ ...errors, [e.target.name]: "" })
//   }

//   const validate = () => {
//     let tempErrors = {}
//     if (!region.region.trim()) {
//       tempErrors.region = "Region is required"
//     }
//     setErrors(tempErrors)
//     return Object.keys(tempErrors).length === 0
//   }

//   const handleAddRegion = async (e) => {
//     e.preventDefault()
//     if (!validate()) return

//     setLoading(true)

//     try {
//       await addRegion(region)

//       toast.success("Region saved successfully.", {
//         position: "top-center",
//         autoClose: 1500,
//       })

//       setRegion(defaultValue)
//       navigate("/region")
//     } catch (err) {
//       console.error("Error adding region:", err)
//       toast.error("Failed to add region. Please try again.")
//     } finally {
//       setLoading(false)
//     }
//   }

const AddRegion = () => {
  const [region, setRegion] = useState(defaultValue);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from URL if editing

  useEffect(() => {
        document.title = "Region | Add Region";
      }, []);

  // If editing, fetch region details
  useEffect(() => {
    if (id) {
      loadRegionDetails(id);
    }
  }, [id]);

  const loadRegionDetails = async (id) => {
    try {
      const response = await getRegionById(id);
      setRegion(response.data);
    } catch (error) {
      console.error("Failed to fetch region:", error);
      toast.error("Error fetching region details.");
    }
  };

  const onValueChange = (e) => {
    setRegion({ ...region, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let tempErrors = {};
    if (!region.region.trim()) {
      tempErrors.region = "Region is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      if (id) {
        // Edit mode
        await updateRegion(id, region);
        toast.success("Region updated successfully.");
      } else {
        // Add mode
        await addRegion(region);
        toast.success("Region added successfully.");
      }

      navigate("/region");
    } catch (err) {
      console.error("Error:", err);
      toast.error(id ? "Failed to update region." : "Failed to add region.");
    } finally {
      setLoading(false);
    }
  };

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
             <h4 className="page-title">{id ? "Edit Region" : "Add Region"}</h4>
            <Link to="/region" className="btn btn-danger">Regions</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Region<span style={{ color: "red" }}>*</span>
</Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.region ? "is-invalid" : ""}`}
                          name="region"
                          placeholder="Enter Region"
                          value={region.region}
                          onChange={onValueChange}
                        />
                        {errors.region && (
                          <div className="invalid-feedback">{errors.region}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div>
                   <Button
  color="primary"
  className="w-md mx-2"
  onClick={handleSubmit} // ✅ Correct function name
  disabled={loading}
>
  {loading ? "Saving..." : "Save"}
</Button>

                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  AddRegion;
